/**
 * fieldFormat — ĐỊNH DẠNG HIỂN THỊ CẤP CỘT cho DataListManager.
 *
 * Bù khoảng trống so với InputBase: `listinfo` có format/align/color/bold/min_width_display cho từng
 * field, còn `data_list_config` trước đây không có gì — số tiền luôn hiện theo Intl vi-VN, không canh
 * phải, không tô màu, không in đậm. Với màn hình chứng từ thì đó là điều người dùng nhận ra đầu tiên.
 *
 * File KHÔNG import gì: numeral/moment được TIÊM vào để (1) không ràng buộc component nào và (2) test
 * chạy được trong node với chính hai thư viện thật.
 */

/** Giá trị coi như rỗng (không hiển thị, không định dạng). */
function isBlank(value) {
	return value === undefined || value === null || value === '';
}

/**
 * Định dạng giá trị theo `field.format`.
 * @returns {string|undefined} chuỗi đã định dạng, hoặc undefined khi kiểu này không có định dạng riêng
 *          (người gọi tự dùng cách hiển thị mặc định sẵn có).
 */
function formatFieldValue(value, field, libs) {
	if (isBlank(value)) return undefined;
	const f = field || {};
	const type = f.type || 'String';
	const numeral = libs && libs.numeral;
	const moment = libs && libs.moment;

	if (type === 'Number') {
		const num = typeof value === 'number' ? value : Number(value);
		if (Number.isNaN(num)) return undefined;
		if (f.format && numeral) {
			try { return numeral(num).format(f.format); } catch (e) { /* rơi về mặc định */ }
		}
		return undefined;   // không khai format -> giữ nguyên cách hiển thị mặc định
	}

	if (type === 'Date' || type === 'DateTime' || type === 'Time') {
		if (!f.format || !moment) return undefined;
		const m = moment(value);
		if (!m || typeof m.isValid !== 'function' || !m.isValid()) return undefined;
		return m.format(f.format);
	}

	return undefined;
}

/**
 * Style của Ô theo khai báo cột. Number mặc định canh PHẢI (thói quen bảng tiền), các kiểu khác canh trái.
 * `color` và `bold` là giá trị tĩnh — đúng như listinfo (`color:String`, `bold:Boolean`), không phải script.
 */
function fieldCellSx(field) {
	const f = field || {};
	const sx = {};
	const align = f.align || (f.type === 'Number' ? 'right' : undefined);
	if (align) sx.textAlign = align;
	if (f.color) sx.color = f.color;
	if (f.bold === true) sx.fontWeight = 700;
	if (f.tableWidth) sx.minWidth = f.tableWidth;
	return sx;
}

export { isBlank, formatFieldValue, fieldCellSx };
